export const KEY_DOWN_EVENT = 'KEY_DOWN_EVENT';
export const KEY_UP_EVENT = 'KEY_UP_EVENT';
export const MOL_MOUSE_EVENT = 'MOL_MOUSE_EVENT';
export const MOUSE_DOWN = 'mousedown';
export const MOUSE_UP = 'mouseup';
export const MOUSE_MOVE = 'mousemove';

// proper events
export const SET_MODE = 'SET_MODE';
export const SET_FRAGMENT_ATOM_MODE = 'SET_FRAGMENT_ATOM_MODE';
export const SET_FRAGMENT_BOND_MODE = 'SET_FRAGMENT_BOND_MODE';
export const PARSE_SMILES = 'PARSE_SMILES';
export const PARSE_NAME = 'PARSE_NAME';
export const SET_MOL = 'SET_MOL';
export const SET_MOLS = 'SET_MOLS';
export const RELAX = 'RELAX';
export const PICK_ELEMENT = 'PICK_ELEMENT';
export const SET_SEARCH = 'SET_SEARCH';

// refined events
export const SET_ELEMENT = 'SET_ELEMENT';
export const MODIFY_CHARGE = 'MODIFY_CHARGE';
export const CLEAR_CHARGE = 'CLEAR_CHARGE';
export const FLIP_BOND_DIRECTION = 'FLIP_BOND_DIRECTION';
export const CLEAR_CHIRAL_BOND = 'CLEAR_CHIRAL_BOND';
export const SET_CHIRAL_BOND = 'SET_CHIRAL_BOND';
export const SET_GEOMETRY_BOND = 'SET_GEOMETRY_BOND';
export const CLEAR_GEOMETRY_BOND = 'CLEAR_GEOMETRY_BOND';
export const FLIP_BOND_GEOMETRY = 'FLIP_BOND_GEOMETRY';
export const ROTATE_AROUND_BOND = 'ROTATE_AROUND_BOND';
export const REMOVE = 'REMOVE';
export const UNDO = 'UNDO';
export const REDO = 'REDO';
export const CUT = 'CUT';
export const COPY = 'COPY';
export const PASTE = 'PASTE';
export const SELECT_ALL = 'SELECT_ALL';
export const ESCAPE = 'ESCAPE';
export const REDRAW = 'REDRAW';
export const FLIP_MOL = 'FLIP_MOL';

// other constants
export const DEFAULT_MODE = 'DEFAULT_MODE';
export const FRAGMENT_ATOM_MODE = 'FRAGMENT_ATOM_MODE';
export const FRAGMENT_BOND_MODE = 'FRAGMENT_BOND_MODE';
export const SELECT_MODE = 'SELECT_MODE';
export const ROTATE_MODE = 'ROTATE_MODE';
export const MOVE_MODE = 'MOVE_MODE';
export const REMOVE_MODE = 'REMOVE_MODE';
export const INCREASE_ATOM_CHARGE_MODE = 'INCREASE_ATOM_CHARGE_MODE';
export const DECREASE_ATOM_CHARGE_MODE = 'DECREASE_ATOM_CHARGE_MODE';
export const TOGGLE_BOND_DASHED_MODE = 'TOGGLE_BOND_DASHED_MODE';
export const TOGGLE_BOND_WEDGED_MODE = 'TOGGLE_BOND_WEDGED_MODE';

// colors
export const DEFAULT_CHANGE_COLOR = '#00000060';
export const ADD_COLOR = '#00000060';
export const REMOVE_COLOR = 'red';
export const SELECT_COLOR = '#34c2c3';

// similar reaction page
export const SIMILAR_REACTION_PAGE_SIZE = 15;

export const SIMILAR_REACTION_QUERY_KEYS = ['srb', 'sri'];
export const STOP_COMPOUNDS_QUERY_KEYS = ['s'];

export const Report = {
  REACTION: 'reaction',
  PATENTED_REACTION: 'patented-reaction',
  SYNTHESIS_TREE: 'synthesis-tree',
};
